// Which rows are a strategist's, and the Strategist selector built from them.
//
// There are six strategists, and `access/roles.json` lists them. The server stamps `has_sdr_owner`
// on every row from that list (owner_state.py), so it is the only test used here: an account the
// bank owns (Vikram, Scout) is Available, and one owned by an AE, a leader or nobody is not a
// strategist's either. Names and addresses are never scraped from `sdr_owner` on their own,
// because that column also carries the bank and anyone a rep reassigned by hand.
//
// Pure, and imported by `node --test`.

import type { BookAccount, StrategistOption } from '../api/types';

export function isStrategistOwned(row: BookAccount): boolean {
  return row.has_sdr_owner === true;
}

// The Strategist Accounts board's rows: every strategist's, or one strategist's by display name.
export function strategistBoardRows(rows: BookAccount[], ownerName: string): BookAccount[] {
  const owned = rows.filter(isStrategistOwned);
  if (!ownerName) return owned;
  return owned.filter(row => row.sdr_owner === ownerName);
}

// The Strategist selector's names, alphabetical: only strategists who own at least one row.
export function strategistOwnerNames(rows: BookAccount[]): string[] {
  const names = new Set<string>();
  for (const row of rows) {
    if (isStrategistOwned(row) && row.sdr_owner) names.add(row.sdr_owner);
  }
  return [...names].sort((first, second) => first.localeCompare(second));
}

// The approval queue's starting owner: the proposed one when they are a listed strategist, else
// none, so an approver picks one of the six. The picker never offers the bank or a requester.
export function queueOwnerStart(proposedOwner: string, strategists: StrategistOption[]): string {
  const proposed = (proposedOwner || '').trim().toLowerCase();
  const listed = strategists.find(row => row.email.toLowerCase() === proposed);
  return listed ? listed.email : '';
}
